import { useEffect, useState } from "react";
import { PresetObj } from "../types/general-types";
import { CollapsibleSection } from "./CollapsibleSection";
import { PresetItem } from "./PresetItem";

type PresetSectionProps = {
	sectionArrays: PresetObj[][];
	presetFavorites: PresetObj[];
	handleSVGClick: any;
	presetSearchInput: string;
	handlePresetSectionUp: (index: number) => void;
	deleteCustomPreset?: (presetName: string) => void;
	handleFavoriteClick: (name: string) => void;
};

export function PresetsRenderSections({
	sectionArrays,
	presetFavorites,
	handleSVGClick,
	presetSearchInput,
	handlePresetSectionUp,
	deleteCustomPreset,
	handleFavoriteClick,
}: PresetSectionProps) {
	//I will allow users to change the ordering of sections
	const [sectionOrder, setSectionOrder] = useState<string[]>([
		"Favorites",
		"Custom",
		"In",
		"In/Out",
		"Out",
	]);
	const [orderedDisplay, setOrderedDisplay] =
		useState<PresetObj[][]>(sectionArrays);

	function orderPresets() {
		let res: PresetObj[][] = [];
		for (let i = 0; i < sectionOrder.length; i++) {
			if (sectionArrays.length === 0) return;
			let foundArray = sectionArrays.find(
				(presetArr) =>
					presetArr.length > 0 && presetArr[0].section === sectionOrder[i]
			);
			if (foundArray) res.push(foundArray);
		}
		setOrderedDisplay(res);
	}

	useEffect(() => {
		orderPresets();
	}, [sectionOrder]);

	return (
		<>
			<CollapsibleSection key={"Favorites"} title={"Favorites"}>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						flexWrap: "wrap",
						justifyContent: "flex-start",
					}}
				>
					{presetFavorites
						.filter((preset) =>
							preset.name
								.toLowerCase()
								.includes(presetSearchInput.toLowerCase())
						)
						.map((preset) => (
							<PresetItem
								key={preset.index}
								index={preset.index}
								value={preset.value}
								name={preset.name}
								isFavorite={preset.isFavorite}
								isStandard={preset.isStandard}
								handleSVGClick={handleSVGClick}
								handleFavoriteClick={() => handleFavoriteClick(preset.name)}
								deleteCustomPreset={deleteCustomPreset}
							/>
						))}
				</div>
			</CollapsibleSection>
			{sectionArrays.map((presetArray, arrayIndex) => {
				if (!presetArray.length) {
					return null;
				}

				const sectionTitle = presetArray[0].section;

				return (
					<CollapsibleSection key={arrayIndex} title={sectionTitle}>
						<div
							style={{
								display: "flex",
								flexDirection: "row",
								flexWrap: "wrap",
								justifyContent: "flex-start",
							}}
						>
							<button
								style={{ backgroundColor: "red" }}
								onClick={() => handlePresetSectionUp(arrayIndex)}
							>
								UP
							</button>
							{presetArray
								.filter((preset) =>
									preset.name
										.toLowerCase()
										.includes(presetSearchInput.toLowerCase())
								)
								.map((preset) => (
									<PresetItem
										key={preset.index}
										index={preset.index}
										value={preset.value}
										name={preset.name}
										isFavorite={preset.isFavorite}
										isStandard={preset.isStandard}
										handleSVGClick={() =>
											handleSVGClick(preset.value, preset.name)
										}
										handleFavoriteClick={() => handleFavoriteClick(preset.name)}
										deleteCustomPreset={deleteCustomPreset}
									/>
								))}
						</div>
					</CollapsibleSection>
				);
			})}
		</>
	);
}
